/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycChangeRequestDto } from '../../models/kyc-change-request-dto';

export interface Close$Params {
  processId: string;
  changeRequestId: string;
}

export function close(http: HttpClient, rootUrl: string, params: Close$Params, context?: HttpContext): Observable<StrictHttpResponse<KycChangeRequestDto>> {
  const rb = new RequestBuilder(rootUrl, close.PATH, 'post');
  if (params) {
    rb.path('processId', params.processId, {});
    rb.path('changeRequestId', params.changeRequestId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycChangeRequestDto>;
    })
  );
}

close.PATH = '/kyc/processes/{processId}/change-requests/{changeRequestId}/close';
